import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const fetchCarteraClienteServicio = (query) => http.get(`${api}/operacion/cartera-clientes-servicio`, { params: { ...query } })

export {
  fetchCarteraClienteServicio
}
